import { configureStore } from '@reduxjs/toolkit';
import React from 'react';
import './index.css';
import '@mdi/font/css/materialdesignicons.css';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { SnackbarProvider, MaterialDesignContent } from 'notistack';
import styled from 'styled-components';
import { HelmetProvider } from 'react-helmet-async';
// import { ReactQueryDevtools } from 'react-query/devtools';
import 'i18n/i18n';

import App from './App';
import rootReducer from './slices';

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent-success': {
    backgroundColor: '#e6f7f5',
    border: '1px solid #0AB39C',
    color: '#0AB39C',
    fontWeight: 'bold',
  },
  '&.notistack-MuiContent-error': {
    backgroundColor: 'rgba(240, 101, 72, 0.1)',
    border: '1px solid #F06548',
    color: '#F06548',
    fontWeight: 'bold',
  },
}));

const store = configureStore({ reducer: rootReducer, devTools: true });
const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);
const queryClient = new QueryClient();
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <HelmetProvider>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <QueryClientProvider client={queryClient}>
            <SnackbarProvider
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              Components={{
                success: StyledMaterialDesignContent,
                error: StyledMaterialDesignContent,
              }}
            >
              <App />
              {/* <ReactQueryDevtools initialIsOpen /> */}
            </SnackbarProvider>
          </QueryClientProvider>
        </BrowserRouter>
      </HelmetProvider>
    </React.StrictMode>
  </Provider>,
);
